export const ILLEGAL_INVOCATION = new TypeError('Illegal invocation 🛑');
